import {remCalc} from '../../_utils'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        cartIcon: {
            '@media (max-width: 1199px)': {
                width: remCalc(24),
                height: remCalc(24),
                color: 'background.dark',
            },
            '@media (min-width: 1200px)': {
                width: remCalc(32),
                height: remCalc(32),
                color: 'background.dark',
            },
        },
        buttonIcons: {
            minWidth: '0',
            minHeight: '0',
        },
        bodyStack: {
            overflowX: 'hidden',
        },
        badge: {
            position: 'absolute',
            textStyle: 'body-xsmall',
            fontWeight: '400',
            borderRadius: 'full',
            alignItems: 'center',
            backgroundColor: 'background.alternative',
            top: remCalc(-5),
            right: remCalc(-8),
            width: remCalc(20),
            height: remCalc(20),
            p: 0,
        },
        miniCartHeader: {
            display: 'flex',
            padding: remCalc(16),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(9),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            textStyle: 'body-medium',
            color: 'text.default',
            fontWeight: '400',
        },
        mediumText: {textStyle: 'body-medium'},
        informationContainer: {
            padding: `${remCalc(16)} 0`,
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        popoverBody: {
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        popoverFooter: {
            paddingInline: remCalc(16),
            paddingY: remCalc(0),
        },
        buttonStack: {
            paddingY: remCalc(16),
        },
        popoverContainer: {
            backgroundColor: 'background-default',
            boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
            width: remCalc(375),
        },
        productHeading: {
            overflow: 'hidden',
            textStyle: 'body-large',
            textOverflow: 'ellipsis',
            color: 'text.default',
            fontWeight: '700',
        },
        flexBody: {
            paddingY: ['xsmall.lg'],
            alignItems: 'flex-start',
            gap: remCalc(9),
            _notLast: {
                borderBottom: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
            },
        },
        namePriceQuantity: {
            alignItems: 'flex-start',
            gap: remCalc(8),
        },
        largeText: {
            textStyle: 'body-large',
            color: 'text.default',
        },
        quantity: {
            textStyle: 'body-xsmall',
            color: 'text.default',
        },
        total: {
            fontWeight: '700',
        },
        vat: {
            textStyle: 'body-xxsmall',
            color: 'text.default',
        },
        priceStack: {
            alignItems: 'center',
            gap: remCalc(8),
        },
        freeShipping: {
            color: 'text.success',
        },
        imageProps: {
            width: '100%',
            height: '100%',
        },
        imageBox: {
            boxSize: '138px',
            minWidth: '138px',
            backgroundColor: 'background.default',
            objectFit: 'cover',
        },
        subtotalSection: {
            shippingName: {
                textStyle: 'body-medium',
            },
            priceAdjustment: {
                textStyle: 'body-large',
            },
            freeShippingText: {
                textStyle: 'body-large',
                color: 'text.success',
            },
            infoIconContainer: {
                display: 'flex',
                alignSelf: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
            },
            infoIcon: {
                w: 'iconsSize.small',
                h: 'iconsSize.small',
                color: 'text.default',
                fill: 'none',
            },
        },
    },
}
